exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.small[data-v-68ac03c9] {\n    max-width: 400px;\n    margin:  0 auto;\n}\n", ""]);

// exports
